import * as React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SectionCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  children: React.ReactNode;
  contentClassName?: string;
}

export function SectionCard({
  title,
  children,
  className,
  contentClassName,
  ...props
}: SectionCardProps) {
  return (
    <div className={cn('relative bg-background', className)} {...props}>
      {/* Title that overlaps with the card border */}
      <div className="absolute -top-3 left-4 px-2 bg-background">
        <h2 className="text-md font-medium text-foreground/80">{title}</h2>
      </div>

      <Card className="pt-6 bg-background border border-border shadow-[0_2px_4px_rgba(0,0,0,0.02)]">
        <CardContent className={cn('pt-2 bg-background rounded-lg', contentClassName)}>
          {children}
        </CardContent>
      </Card>
    </div>
  );
}
